import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function ForbiddenPage() {
  return (
    <>
      <SEO
        title="403 - Adgang nægtet | Tømrermester Jacob"
        description="Du har ikke adgang til denne side."
      />

      <section className="py-20 lg:py-32 bg-stone-50 min-h-[70vh] flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 text-center space-y-6">
          <div className="w-16 h-16 rounded-2xl bg-rose-100 text-rose-800 flex items-center justify-center mx-auto text-2xl font-bold">
            <i className="fa-solid fa-lock" aria-hidden="true"></i>
          </div>

          <span className="text-xs font-bold uppercase tracking-widest text-rose-800 bg-rose-100/80 px-3 py-1 rounded-full">
            Fejlkode 403
          </span>

          <h1 className="text-3xl sm:text-4xl font-bold text-stone-900 tracking-tight">
            Adgang nægtet
          </h1>

          <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
            Du har desværre ikke tilladelse til at tilgå denne ressource.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center px-7 py-3.5 rounded-full bg-[#ce0611] hover:bg-[#b0040e] text-white font-semibold text-sm shadow-sm transition-all"
            >
              <i className="fa-solid fa-house mr-2 text-xs" aria-hidden="true"></i>
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center px-6 py-3.5 rounded-full bg-white hover:bg-stone-100 text-stone-800 font-semibold text-sm border border-stone-300 shadow-xs transition-colors"
            >
              <i className="fa-solid fa-envelope mr-2 text-[#ce0611]" aria-hidden="true"></i>
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
